var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (containerAttributes, fieldsetCounter, fileInputAttributes, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["dropzone"] = pug_interp = function(model, single, id, tags, employeeId, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
containerAttributes = {}
fileInputAttributes = {}
if (single) {
containerAttributes = { 'made-dropzone-single' : 'true' }
fileInputAttributes = { 'made-file-single' : 'true' }
}
else {
fileInputAttributes = { multiple : 'multiple' }
}
if (!id) {
id = 'uploader'
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "dropzone-container","made-dropzone": pug.escape(model)},containerAttributes,attributes]), true)) + "\u003E\u003Cdiv class=\"dropzone-inner-container\"\u003E";
if (employeeId) {
pug_html = pug_html + "\u003Cfile-chooser" + (pug.attr("files", model, true, true)+pug.attr("filter-tags", tags, true, true)+pug.attr("employee-id", employeeId, true, true)) + "\u003E\u003C\u002Ffile-chooser\u003E\u003Cdiv class=\"divider\"\u003Eoder\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + ("\u003Cdiv class=\"drag-and-drop-label\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsvg\u002Ficon-download.svg\"\u003E" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)));
if (single) {
pug_html = pug_html + "\u003Cspan\u003EDatei hierherziehen\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003EDateien hierherziehen\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"divider\"\u003Eoder\u003C\u002Fdiv\u003E\u003Cdiv class=\"file-input\"\u003E\u003Cinput" + (pug.attrs(pug.merge([{"id": pug.escape(id),"type": "file","made-file-input": pug.escape(model),"style": "visibility:hidden","data-cy": pug.escape(cyData)},fileInputAttributes]), true)) + "\u003E";
if (single) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("for", id, true, true)) + "\u003E\u003Cspan class=\"button\"\u003EDatei auswählen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
else {
pug_html = pug_html + "\u003Clabel" + (pug.attr("for", id, true, true)) + "\u003E\u003Cspan class=\"button\"\u003EDateien auswählen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"files\"\u003E";
if (block) {
block && block();
}
else
if (single) {
pug_html = pug_html + "\u003Cspan" + (pug.attr("ng-if", model +' && !'+ model +'._id', true, true)) + "\u003E" + (pug.escape(null == (pug_interp = ' {{ '+ model +'.name }} ({{ '+ model +'.size | filesize }})') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Ca" + (pug.attr("ng-if", model +' && !'+ model +'._id', true, true)+pug.attr("ng-click", model + '=undefined', true, true)) + "\u003E\u003Ci class=\"font-icon icon-close right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca" + (pug.attr("ng-if", model +'._id', true, true)+pug.attr("ng-href", '/gridfs?id={{'+ model +'._id}}', true, true)+" target=\"_blank\" rel=\"noreferrer\"") + "\u003E" + (pug.escape(null == (pug_interp = ' {{ '+ model +'.name }} ({{ '+ model +'.size | filesize }})') ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"files\""+pug.attr("ng-repeat", '(index, file) in ' + model, true, true)) + "\u003E\u003Cspan ng-if=\"!file._id\"\u003E{{ file.name }} ({{ file.size | filesize }})\u003C\u002Fspan\u003E\u003Ca" + (pug.attr("ng-click", model + '.splice(index, 1)', true, true)) + "\u003E\u003Ci class=\"font-icon icon-close right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca ng-if=\"file._id\" ng-href=\"\u002Fgridfs?id={{ file._id }}\" target=\"_blank\" rel=\"noreferrer\"\u003E{{ file.filename }} ({{ file.meta.created *1000 | date }}, {{ file.length | filesize }})\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel__title\" ng-if=\"!$ctrl.loading\"\u003E{{$ctrl.employee_id}} | {{$ctrl.customer.name}} | {{ $ctrl.employee.lastname }}, {{ $ctrl.employee.firstname }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv ng-if=\"$ctrl.employee_status.id === $ctrl.NAME_EMPLOYEE_STATUSES_MAP['kontrolle_t']['id']\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003ESchritt: Dokumente EVG erzeugen und drucken\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.iHaveAccess()\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDatensatz in Bearbeitung durch  {{ $ctrl.employee_lock.by_advisor.id }}, {{ $ctrl.employee_lock.by_advisor.firstname }} {{ $ctrl.employee_lock.by_advisor.lastname }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.contract === null\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDer Arbeitnehmer hat keinen finalisierten Vertrag.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.iHaveAccess() || $ctrl.contract === null\" ng-click=\"$ctrl.openEVGDocument()\" data-cy=\"vn.administration.neo.controlProcessPrintDialog.buttonDownloadContract\"\u003EErgänzende Vereinbarung erzeugen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv\u003EBitte bestätigen Sie den Druck der Dokumente\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.iHaveAccess() || $ctrl.contract === null\" ng-click=\"$ctrl.updateEmployeeStatus()\" data-cy=\"vn.administration.neo.controlProcessPrintDialog.buttonConfirmPrint\"\u003EDokumente wurden gedruckt\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.employee_status.id === $ctrl.NAME_EMPLOYEE_STATUSES_MAP['kontrolle_p1']['id']\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003ESchritt: Dokumente versenden\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.iHaveAccess()\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDatensatz in Bearbeitung durch  {{ $ctrl.employee_lock.by_advisor.id }}, {{ $ctrl.employee_lock.by_advisor.firstname }} {{ $ctrl.employee_lock.by_advisor.lastname }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.contract === null\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDer Arbeitnehmer hat keinen finalisierten Vertrag.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv\u003EBitte bestätigen Sie den Versand der Dokumente\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.iHaveAccess() || $ctrl.contract === null\" data-cy=\"vn.administration.neo.controlProcessSendDialog.buttonConfirmSend\" ng-click=\"$ctrl.updateEmployeeStatus()\"\u003EDokumente wurden versendet\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.employee_status.id == $ctrl.NAME_EMPLOYEE_STATUSES_MAP['kontrolle_p2']['id']\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003ESchritt: Dokumente Eingang bestätigen\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.iHaveAccess()\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDatensatz in Bearbeitung durch  {{ $ctrl.employee_lock.by_advisor.id }}, {{ $ctrl.employee_lock.by_advisor.firstname }} {{ $ctrl.employee_lock.by_advisor.lastname }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.contract === null\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDer Arbeitnehmer hat keinen finalisierten Vertrag.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv\u003EBitte bestätigen Sie den Eingang der Dokumente\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.iHaveAccess() || $ctrl.contract === null\" ng-click=\"$ctrl.updateEmployeeStatus()\" data-cy=\"vn.administration.neo.controlProcessReceiveDialog.buttonConfirmReceive\"\u003EDokumente sind eigengangen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.employee_status.id == $ctrl.NAME_EMPLOYEE_STATUSES_MAP['kontrolle_p3']['id']\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003ESchritt: EVG Dokumente prüfen\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.iHaveAccess()\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDatensatz in Bearbeitung durch  {{ $ctrl.employee_lock.by_advisor.id }}, {{ $ctrl.employee_lock.by_advisor.firstname }} {{ $ctrl.employee_lock.by_advisor.lastname }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.contract === null\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDer Arbeitnehmer hat keinen finalisierten Vertrag.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E";
pug_mixins["dropzone"](
        '$ctrl.evg_files',
        undefined,
        undefined,
        undefined,
        undefined,
        'vn.administration.neo.controlProcessContractDialog.fileContract'
      );
pug_html = pug_html + "\u003Cdiv class=\"helpText\" ng-if=\"!$ctrl.areEvgFilesValid()\"\u003EEs wird eine Eingabe benötigt\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EKommentar\u002F Korrekturhinweis\u003C\u002Fh3\u003E\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "comment","data-cy": "vn.administration.neo.controlProcessContractDialog.inputComment","attributes": {"ng-disabled":"!$ctrl.iHaveAccess() || $ctrl.contract === null","ng-required":"true"},"validationMessages": {"required":"Es wird eine Eingabe benötigt."}}
});
},
attributes: {"name": "$ctrl.documentErrorCommentForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 center\"\u003E\u003Cbutton class=\"button button-primary\" ng-disabled=\"!$ctrl.areEvgFilesValid() || !$ctrl.iHaveAccess() || $ctrl.contract === null\" ng-click=\"$ctrl.confirmDocuments()\" data-cy=\"vn.administration.neo.controlProcessContractDialog.buttonApprove\"\u003EDokumente sind in Ordnung\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 center\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.rejectDocuments()\" ng-disabled=\"!$ctrl.documentErrorCommentForm.$valid || !$ctrl.iHaveAccess() || $ctrl.contract === null\" data-cy=\"vn.administration.neo.controlProcessContractDialog.buttonDecline\"\u003EDokumente fehlerhaft\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.employee_status.id == $ctrl.NAME_EMPLOYEE_STATUSES_MAP['kontrolle_p6']['id']\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003ESchritt: Warten auf Digitale Signatur\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.iHaveAccess()\"\u003E\u003Cdiv class=\"column locked-warning\"\u003E\u003Cspan\u003EDatensatz in Bearbeitung durch  {{ $ctrl.employee_lock.by_advisor.id }}, {{ $ctrl.employee_lock.by_advisor.firstname }} {{ $ctrl.employee_lock.by_advisor.lastname }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column\"\u003E\u003Cdiv class=\"info_area\"\u003E\u003Ch3\u003EKommentar\u002F Korrekturhinweis\u003C\u002Fh3\u003E\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "comment","data-cy": "neo.postCheckout.basicComponents.controlDialog.inputCommentCancelDigitalSignature","attributes": {"ng-disabled":"!$ctrl.iHaveAccess()","ng-required":"true"},"validationMessages": {"required":"Es wird eine Eingabe benötigt."}}
});
},
attributes: {"name": "$ctrl.digitalSignatureCancellationForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 center\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.cancelDigitalSigning()\" ng-disabled=\"!$ctrl.digitalSignatureCancellationForm.$valid || !$ctrl.iHaveAccess()\"\u003ESignaturanforderung zurücknehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "containerAttributes" in locals_for_with ?
        locals_for_with.containerAttributes :
        typeof containerAttributes !== 'undefined' ? containerAttributes : undefined, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "fileInputAttributes" in locals_for_with ?
        locals_for_with.fileInputAttributes :
        typeof fileInputAttributes !== 'undefined' ? fileInputAttributes : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;